// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pay-now {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
}

.pay-now-header {
    display: flex;
    flex-flow: column;
}


.pay-now-header h2 {
    margin: 10px;
    color: #004BA0;
    text-align: center;
}

.pay-now-header span {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
}

.surveyheart-icon {
    display: flex;
    justify-content: center;
}

.surveyheart-icon img {
    width: 24px;
}

.surveyheart-icon h2 {
    margin: 5px;
    color: #212121;
    font-size: 20px;
}

.pay-now-body {
    display: flex;
    justify-content: center;
}


.feature-row {
    display: flex;
    margin: 10px 0;
    text-align: justify;
}

.feature-row img {
    width: 35px;
    height: 35px;
    margin: 10px 30px;
}

.row-text h2 {
    margin: 0;
    font-size: 20px;
    color: #424242;
}

.row-text p {
    margin: 0;
    color: #8E8E8E;
    font-size: 14px;
}

@media only screen and (max-width: 600px) {
    .pay-now-body {
        display: block;
        margin: 20px 0 50px;
    }

    .row-text {
        margin: 0 10px 0 0;
        padding-bottom: 10px;
        border-bottom: 0.5px solid #8E8E8E;
    }

    .row-text h2 {
        font-size: 18px;
    }

    .feature-row img {
        margin: 10px;
    }

    .pay-button {
        bottom: 0;
        width: 100%;
        position: fixed;
        text-align: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/pay-now-popup.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;;AAGA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,kCAAkC;IACtC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,eAAe;QACf,kBAAkB;IACtB;AACJ","sourcesContent":[".pay-now {\n    width: 100%;\n    height: 100%;\n    background-color: #FFFFFF;\n}\n\n.pay-now-header {\n    display: flex;\n    flex-flow: column;\n}\n\n\n.pay-now-header h2 {\n    margin: 10px;\n    color: #004BA0;\n    text-align: center;\n}\n\n.pay-now-header span {\n    font-size: 20px;\n    font-weight: bold;\n    text-align: center;\n}\n\n.surveyheart-icon {\n    display: flex;\n    justify-content: center;\n}\n\n.surveyheart-icon img {\n    width: 24px;\n}\n\n.surveyheart-icon h2 {\n    margin: 5px;\n    color: #212121;\n    font-size: 20px;\n}\n\n.pay-now-body {\n    display: flex;\n    justify-content: center;\n}\n\n\n.feature-row {\n    display: flex;\n    margin: 10px 0;\n    text-align: justify;\n}\n\n.feature-row img {\n    width: 35px;\n    height: 35px;\n    margin: 10px 30px;\n}\n\n.row-text h2 {\n    margin: 0;\n    font-size: 20px;\n    color: #424242;\n}\n\n.row-text p {\n    margin: 0;\n    color: #8E8E8E;\n    font-size: 14px;\n}\n\n@media only screen and (max-width: 600px) {\n    .pay-now-body {\n        display: block;\n        margin: 20px 0 50px;\n    }\n\n    .row-text {\n        margin: 0 10px 0 0;\n        padding-bottom: 10px;\n        border-bottom: 0.5px solid #8E8E8E;\n    }\n\n    .row-text h2 {\n        font-size: 18px;\n    }\n\n    .feature-row img {\n        margin: 10px;\n    }\n\n    .pay-button {\n        bottom: 0;\n        width: 100%;\n        position: fixed;\n        text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
